<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>
      <header>
        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="banner && datas.focus_pics_is_show == 1" v-for="(item, index) in banner"
              v-bind:key="index"><img :src="'../../static/images/Normal04/' + item"></div>
          </div>
        </div>
      </header>

      <!-- 北京同仁堂class特殊处理 -->
      <section
        class="box"
        :class="{
          'trt': datas.business.rootid === '100700001',
          'tyyy': datas.business.rootid == '100010342'
        }">

        <div class="MainOidBox">
          <ul>
            <li>国家OID注册中心</li>
            <li class="MainOid">
              <i v-if="datas.business.company_idcode" v-text="datas.business.company_idcode"></i>
              <i v-else>1.2.156.40000.{{ datas.business.rootid }}</i>
            </li>
            <li>工信部授权的标识体系，全球可查验</li>
          </ul>
        </div>

        <!-- 查询输入框 -->
        <div class="MainDatasBox NoBottom" style="padding-bottom: 0;" v-if="datas.antifake_is_show">
          <input class="MainDataInquire" v-model="verify" @keyup.enter="InquireFun" :placeholder="placeholder" />
          <i class="MainDataInquireBtn" @click="InquireFun">查询</i>
        </div>

        <!-- 查询信息 -->
        <div class="MainBox" v-if="queryContent">
          <div class="MainTitle">查询信息</div>
          <div class="MainDatasBox">
            <ul class="MainData">
              <li class="MainDataLeft">首次查询地点</li>
              <li class="MainDataRight" v-text="queryContent.query_first_address"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">首次查询时间</li>
              <li class="MainDataRight" v-text="queryContent.query_first_time"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">查询次数</li>
              <li class="MainDataRight" v-text="queryContent.query_count"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">查询记录</li>
              <li class="MainDataRight " @click="ViewMore(2)">点击查看全部 》</li>
            </ul>
            <ul class="MainData">
              <li class="MainDataTip" v-if="queryContent.query_count > 1 && !datas.many_antifake_msg">您查询的码标已经被多次扫描，谨防假冒!</li>
              <li class="MainDataTip" v-if="queryContent.query_count > 1 && datas.many_antifake_msg" >{{ datas.many_antifake_msg }}</li>
              <li class="MainDataTip" v-if="queryContent.query_count <= 1 && !datas.first_antifake_msg" >您查询的是 {{ datas.business.name }} 的正牌产品，请您放心使用!</li>
              <li class="MainDataTip" v-if="queryContent.query_count <= 1 && datas.first_antifake_msg" >{{ datas.first_antifake_msg }}</li>
            </ul>
          </div>
        </div>

        <!-- 焦点图 -->
        <div class="MainBox" v-if="datas.focus && datas.focus.length && datas.prod_is_show == 1">
          <viewer @inited="inited" ref="viewer">
            <div class="swiper-container bannerbox">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                  v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
              </div>
            </div>
          </viewer>
        </div>

        <!-- 地图 -->
        <div class="MainBox" v-if="location">
          <div class="box-three" id="map"></div>
        </div>

        <!-- 产品信息 -->
        <div class="MainBox" v-if="datas.product && datas.prod_is_show == 1">
          <div class="MainTitle">产品信息</div>
          <div class="MainDatasBox">
            <div><img class="proimg" :src="datas.product.img" /></div>
            <ul class="MainData" v-if="datas.prod_name_is_show == 1">
              <li class="MainDataLeft">品名</li>
              <li class="MainDataRight" v-text="datas.product.name"></li>
            </ul>
            <ul class="MainData" v-if="datas.attribute && datas.attribute.ship_date">
              <li class="MainDataLeft">生产日期</li>
              <li class="MainDataRight" v-text="datas.attribute.ship_date"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.period && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">保质期</li>
              <li class="MainDataRight" v-text="datas.product.period"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.unit && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">规格</li>
              <li class="MainDataRight" v-text="datas.product.unit"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.introduce && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">介绍</li>
              <li class="MainDataRight" v-text="datas.product.introduce"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.attribute" v-for="val in datas.product.attribute">
              <li class="MainDataLeft" v-text="val.key"></li>
              <li class="MainDataRight" v-text="val.value"></li>
            </ul>
          </div>
        </div>

        <!-- 商户信息 -->
        <viewer @inited="inited" ref="viewer">
          <div id="business-box" class="MainBox" v-if="datas.business && datas.business_is_show == 1">
            <div class="MainTitle">商户信息</div>
            <div class="MainDatasBox">
              <ul class="MainData">
                <li class="MainDataLeft">商户名称</li>
                <li class="MainDataRight" v-text="datas.business.name"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.linkman">
                <li class="MainDataLeft">联 系 人</li>
                <li class="MainDataRight" v-text="datas.business.linkman"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.linkphone">
                <li class="MainDataLeft">联系方式</li>
                <li class="MainDataRight" v-text="datas.business.linkphone"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.baddress">
                <li class="MainDataLeft">商户地址</li>
                <li class="MainDataRight" v-text="datas.business.baddress"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.intro">
                <li class="MainDataLeft">商户简介</li>
                <li class="MainDataRight" v-text="datas.business.intro"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
                <li class="MainDataLeft" v-text="val.key" v-if="val.key != '经纬度'"></li>
                <li class="MainDataRight" v-text="val.value" v-if="val.key != '经纬度'"></li>
              </ul>
            </div>
          </div>

          <!-- 质检信息 -->
          <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
            <div class="MainTitle">质检信息</div>
            <div class="MainDatasBox">
              <ul class="MainData" v-for="(item, index) in datas.batch.qc" v-bind:key="index">
                <li class="MainDataLeft" v-text="item.key"></li>
                <li class="MainDataRight" v-text="item.value" v-if="item.ix == 0"></li>
                <li class="MainDataRight MainDataRightImg backImg" v-else
                  :style="{ backgroundImage: 'url(' + item.value + ')' }"><img class="OpacityImg" :src="item.value"></li>
              </ul>
            </div>
          </div>

          <!-- 生产流程 -->
          <div id="trace-box" class="MainBox" v-if="datas.process && datas.process_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 生产流程演示 -->
          <div id="trace-box" class="MainBox"
            v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process_demo" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process_demo.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 经销商流程 -->
          <div id="trace-box" class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1">
            <div class="MainTitle">经销商流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.dealer" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.dealer.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 经销商详情 -->
          <div id="business-box" class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1">
            <div class="MainTitle">经销商详情</div>
            <div class="MainDatasBox">
              <div class="MainDatasLine" v-for="(item, index) in datas.dealer" v-bind:key="index">
                <ul class="MainData">
                  <li class="MainDataLeft">名称</li>
                  <li class="MainDataRight" v-text="item.name"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系人</li>
                  <li class="MainDataRight" v-text="item.linkman"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系电话</li>
                  <li class="MainDataRight" v-text="item.linkphone"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系地址</li>
                  <li class="MainDataRight" v-text="item.linkaddress"></li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 视频信息 -->
          <div id="video-box" class="MainBox" v-if="datas.video && datas.video_is_show == 1">
            <div class="MainTitle">视频信息</div>
            <div class="MainDatasBox">
              <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
                <source :src="datas.video.url" type="video/mp4">
              </video>
            </div>
          </div>

          <!-- 自定义栏目 -->
          <div id="ref-box" class="MainBox" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item, index) in datas.ref"
            v-bind:key="index">
            <div class="MainTitle" v-text="item.name"></div>
            <ul class="MainRefDatasBox">
              <li v-for="(val, ix) in item.datas" v-bind:key="ix">
                <p class="MainRefDatasTxt" v-if="val.type == 0" v-text="val.data"></p>
                <img v-else :src="val.data">
              </li>

              <!-- 跳转按钮 -->
              <div v-if="datas.jump_link" class="wx-btn-box">

                <!-- 小程序 -->
                <template v-if="datas.business.appid && datas.jump_link.substring(0, 6).indexOf('pages') != -1">
                  <wx-open-launch-weapp id="launch-btn" :appid="datas.business.appid" :path="datas.jump_link">
                    <script type="text/wxtag-template">
                        <button style="width:100%;box-sizing: border-box; height: 45px; text-align: center; font-size: 17px; display: block; margin: 0 auto; padding: 8px 30px; border: none; border-radius: 6px; background-color: #f06c2c; color:#fff;">查看更多产品信息</button>
                    </script>
                  </wx-open-launch-weapp>
                </template>

                <!-- 其它 -->
                <a :href="datas.jump_link" target="_blank" v-else style="width:100%;box-sizing: border-box; height: 45px; text-align: center; font-size: 17px; display: block; margin: 0 auto; border: none; border-radius: 6px; background-color: #f06c2c; color:#fff;">查看更多产品信息</a>

              </div>

            </ul>
          </div>

          <!-- 自定义底部菜单 -->
          <div id="menu-box" class="MainBox MainMenuBox" v-if="datas.menu && datas.menu.length && datas.menu_is_show == 1">
            <ul class="MainMenuRow CliclStyle" v-for="(item, index) in datas.menu" v-bind:key="index"
              @click="ClickMenu(item)">
              <li class="MainMenuIcon">
                <i v-if="item.icon" class="backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></i>
                <i v-else class="backImg"
                  :style="{ backgroundImage: 'url(../../static/images/icon' + item.type + '.png)' }"></i>
                <span class="icon iconfont iconyou MainMenuArrows"></span>
              </li>
              <li class="MainMenuDatas">
                <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
                <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
              </li>
            </ul>
          </div>

          <!-- 模块索引 -->
          <div class="ModuleIndex" v-if="datas.module_index_is_show == 1">
            <ul>
              <li v-for="item in ModulList" @click="ClickModul(item.id)">
                <div v-text="item.name"></div>
              </li>
            </ul>
          </div>

        </viewer>

        <!-- 底部logo图 -->
        <img v-if="datas.business.rootid == '100010342'" class="bottom-logo" src="/static/images/Normal06/tyyy-logo.jpg" />

      </section>

    </div>

    <!-- 创建一个隐藏的audio元素 -->
    <audio id="audioPlayer" style="display: none;"></audio>
  </div>
</template>

<script>
let self, map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal06',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      verify: '',
      code: null,
      count: 2,
      boxStyle: {},
      queryContent: null,
      banner: ["banner01.png", "banner02.png", "banner03.png"],
      datas: null,
      placeholder: "",
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      },
      location: null,
      ModulList: [{
        id: "business-box",
        name: "商户"
      }, {
        id: "trace-box",
        name: "溯源"
      }, {
        id: "video-box",
        name: "视频"
      }, {
        id: "ref-box",
        name: "推荐"
      }, {
        id: "menu-box",
        name: "菜单"
      }]
    }
  },
  created() {
    self = this;
    document.title = "国家OID注册中心行业节点";  //设置页面标题
    document.querySelector('body').setAttribute('style', 'background-color:#2536e8');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }


  },
  updated() {
    new Swiper('.banner', {
      autoplay: true,//可选选项，自动滑动
      loop: true, //可选选项，开启循环
    })

    if (self.datas.video) {
      this.initVideo();
    }

    new Swiper('.bannerbox', {
      autoplay: {
        delay: 2000
      },//可选选项，自动滑动
      loop: true, //可选选项，开启循环
      autoHeight: true, //高度随内容变化
    })

    self.CreateMap();
  },
  methods: {
    async loadWxInfo(){
      await this.getWXInfo()
      wx.ready(function (res2) {
        self.msg = "ready";
        var launchBtn = document.getElementById('launch-btn')
        launchBtn.addEventListener('ready', function (e) {
          self.msg = '开放标签 ready';
          // 无法触发自动点击
          // setTimeout(() => {
          //   launchBtn.click();
          // }, 3000);
        })
        launchBtn.addEventListener('launch', function (e) {
          self.msg = '开放标签 success';
        })
        launchBtn.addEventListener('error', function (e) {
          self.msg = '开放标签 fail';
        })
      });
    },
    getSignUrl() {
      var signLink = ''
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        signLink = `https://lj.oid.plus/?${this.code}`;
      } else {
        signLink = location.href
      }
      return signLink;
    },
    getWXInfo: function () {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "post",
          url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
          dataType: 'json',
          data: {
            url: this.getSignUrl(),
            syid: "100010034"
          },
          success: function (res) {
            if (res.code == 200) {
              resolve(true);
              wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: ['scanQRCode', "getLocation"],
                openTagList: ['wx-open-launch-weapp']
              });
            } else {
              resolve(false);
            }
          },
          error: function (err) {
            resolve(false);
          }
        });
      })
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          self.datas = datas;
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          self.verify = response.data.meta.verify;


          //北京同仁堂特殊处理
          self.placeholder = "请在此输入防伪码";
          if(datas.business.rootid === '100700001'){
            self.placeholder = "请扫码查询";
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);

            if (datas.business.customize_data) {
              for (let i in datas.business.customize_data) {
                if (datas.business.customize_data[i].key == "经纬度") {
                  self.location = datas.business.customize_data[i].value;
                }
              }
            }
          }
          //企业填写小程序appid
          if(datas.business.appid){
            self.loadWxInfo();
          }
          //自定义属性
          if(response.data.meta.activation_a){
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);

            //自动转换新域名
            // if(datas.video.url){
            //   let videoUrl = datas.video.url.substring(12,17);
            //   if(videoUrl == "wwmxt"){
            //     datas.video.url = self.GetVideoUrl() + datas.video.url.substring(20,datas.video.url.length)
            //   }
            // }

          }
          datas.activity_is_show = 1;
          self.datas = datas;

          //特殊判断，自动跳转小程序
          if(['100700001', '100010002', '100010016'].indexOf(datas.business.rootid) != -1){
            self.getScheme({rootid: datas.business.rootid, path: datas.jump_link});
          }

        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    initVideo() {
      //初始化视频方法
      try {
        let myPlayer = this.$video(VideoBox, {
          controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          autoplay: false,  //自动播放属性,muted:静音播放
          preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        });
      } catch (error) {
        console.log(error)
      }
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    },
    ClickModul(id) {
      if ($("#" + id).offset()) {
        let top = $("#" + id).offset().top;
        $("html,body").animate({ scrollTop: top - 15 }, 300);
      }
    },
    CreateMap() {
      if (self.location) {
        let ll = self.location.split(",");
        map = new BMap.Map("map"); // 创建Map实例
        var point = new BMap.Point(ll[0], ll[1]);
        var marker = new BMap.Marker(point);
        let left = self.datas.business.name.length * 6;
        var label = new BMap.Label(self.datas.business.name, { offset: new BMap.Size('-' + left, 26) });
        label.setStyle({
          color: "black",
          border: '0px',
          fontSize: "12px",
          height: "20px",
          padding: "0 10px",
          lineHeight: "20px",
          fontFamily: "微软雅黑"
        });
        marker.setLabel(label);
        map.addOverlay(marker);
        map.centerAndZoom(point, 13); // 初始化地图,设置中心点坐标和地图级别
        map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      }
    },
    InquireFun() {
      if(!this.verify) return;
      this.queryContent = null;
      this.CodeVerify(axios, (e)=> {
        this.queryContent = e.data.meta;
        let msg;
        if(this.queryContent.query_count > 1 && !this.datas.many_antifake_msg){
          msg = "您查询的码标已经被多次扫描，谨防假冒!";
        }
        if(this.queryContent.query_count > 1 && this.datas.many_antifake_msg){
          msg = this.datas.many_antifake_msg;
        }
        if(this.queryContent.query_count <= 1 && !this.datas.first_antifake_msg){
          msg = `您查询的是 ${this.datas.business.name} 的正牌产品，请您放心使用!`;
        }
        if(this.queryContent.query_count <= 1 && this.datas.first_antifake_msg){
          msg = this.datas.first_antifake_msg;
        }
        if(msg && this.datas.antifake_auto){
          try {
            this.playAudio(msg);
            // this.speaker = new Speaker({ text: msg });
            // if(this.speaker){
            //   setTimeout(()=>{
            //     this.speaker.start(); // 开时播放
            //   },300)
            // }
          } catch (error) {
            console.log(error);
          }
        }
      })

    },
    playAudio(msg){
      const audioPlayer = document.getElementById('audioPlayer');
      audioPlayer.src = this.GetServerUrl(1) + `getVoice?text=${msg}`;
      audioPlayer.load();  // 加载音频文件
      audioPlayer.play();  // 播放音频
    },
    getScheme({rootid, path}){
      $.ajax({
        type: "post",
        url: self.GetServerUrl(1) + "getScheme",
        dataType: 'json',
        data: {
          code: this.code,
          rootid,
          path: ''
        },
        success: function (res) {
          if (res.code == 200) {
            //setTimeout(() => { //3秒后自动跳转
              window.location.href = res.meta.openlink;
            //}, 2000);
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.box {
  padding-bottom: 40px;
}

.MainDataInquire {
  margin-top: 13px;
  border-radius: 3px;
  padding: 0 10px;
  height: 45px;
  font-size: 16px;
  width: calc(100% - 22.5px);
  border: 2px solid rgba(69, 84, 235, 0.98);
}

.MainDataInquireBtn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 60px;
  line-height: 45px;
  display: table;
  background-color: rgba(69, 84, 235, 0.98);
  text-align: center;
  color: #FFF;
  z-index: 99;
  border-radius: 0;
}

.banner {
  overflow: hidden;
}

.banner img {
  display: block;
  width: 100%;
}

.bannerbox {
  border-radius: .25rem;
  overflow: hidden;
}

.bannerbox img {
  display: block;
  width: 100%;
}

.MainOidBox {
  padding: .6rem;
  padding-bottom: 0;
}

.MainOidBox ul {
  padding: .6rem;
  text-align: center;
  color: #fff;
  font-size: .6rem;
  font-weight: bold;
  background-image: url(../../static/images/Normal04/box.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.MainOidBox ul li {
  margin-top: 5px;
}

.MainOid {
  font-size: .65rem;
}

.MainBox {
  overflow: hidden;
  border-radius: .25rem;
  margin: .6rem;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 5px rgba(100, 100, 100, 0.2);
}

.MainTitle {
  font-size: .58rem;
  padding: .6rem;
  border-radius: .25rem .25rem 0 0;
  background-color: rgba(255, 255, 255, 0.1);
  font-weight: 600;
  letter-spacing: .05rem;
}

.MainDatasBox {
  font-size: .58rem;
  padding: 0 .6rem;
  padding-bottom: 0.6rem;
  word-wrap: break-word;
  position: relative;
}

.MainData {
  line-height: .7rem;
  padding-top: .6rem;
  padding-bottom: .2rem;
  position: relative;
}

.MainDatasLine {
  padding: 10px 0 20px 0;
  border-top: 1px dashed #FFF;
}

.MainDatasLine:first-child {
  border: 0;
}

.MainData:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}

.MainData:last-child {
  padding-bottom: 0;
}

.MainDataLeft {
  width: 5rem;
  float: left;
}

.MainDataRight {
  width: calc(100% - 5rem);
  float: right;
  text-align: right;
}

.MainDataRightImg {
  width: 7rem !important;
  height: 4rem;
  overflow: hidden;
}

.MainDataHint {
  margin-top: .1rem;
  color: #fff;
  font-size: .55rem;
}

/* 溯源信息 */
.TraceData {
  padding-left: 1rem;
  padding-top: 0;
  padding-bottom: 1rem;
}

.TraceData:first-child {
  margin-top: .6rem;
}

.TraceDataDotBox {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: .45rem;
  height: .7rem;
  background-color: #2C5DE8;
  z-index: 99;
}

.TraceDataDot {
  display: block;
  position: absolute;
  width: .3rem;
  height: .3rem;
  margin-top: .12rem;
  border: 2px solid #fff;
  border-radius: .3rem;
  z-index: 99;
}

.TraceDataDotBottomBox {
  top: auto;
  bottom: 0;
}

.TraceDataLine {
  display: block;
  position: absolute;
  top: .2rem;
  left: .186rem;
  bottom: 0;
  border-left: 2px dashed #fff;
  z-index: 98;
}

.VideoBox {
  margin-top: .6rem;
  width: 100%;
}

.MainRefDatasBox {
  padding: .6rem;
}

.MainRefDatasBox li:first-child {
  margin-top: 0;
}

.MainRefDatasBox li {
  line-height: .9rem;
  font-size: .58rem;
  margin-top: .3rem;
}

.MainRefDatasBox li img {
  display: block;
  width: 100%;
}

.MainRefDatasTxt {
  text-indent: .8rem;
}

.MainMenuRow {
  padding: .5rem;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #F3F3F3;
}

.MainMenuRow:last-child {
  border-bottom: 0;
}

.MainMenuIcon {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  background-color: #5865ed;
  margin-right: .5rem;
  border-radius: .2rem;
}

.MainMenuIcon i {
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  margin: .4rem;
}

.MainMenuDatas {
  float: left;
  width: calc(100% - 3.5rem);
}

.MainMenuDatasTit {
  margin-top: .1rem;
  font-size: .58rem;
}

.MainMenuDatasTxt {
  font-size: .55rem;
  color: #FFF;
  margin-top: .15rem;
}

.MainMenuArrows {
  position: absolute;
  right: .5rem;
  top: calc(50% - .4rem);
  color: #fff;
  font-size: .55rem;
}

.CliclStyle:active {
  background: #F6F6F6;
}

.CliclStyle:focus {
  background: #FFF;
}

#map {
  height: 300px;
  opacity: 0.7;
}

.proimg {
  width: 100%;
  display: block;
  margin-top: 10px;
}

.ModuleIndex {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 99;
  background-color: rgba(69, 84, 235, 0.98);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.1);
}

.ModuleIndex ul {
  overflow: hidden;
  padding: 12px 0;
}

.ModuleIndex ul li {
  float: left;
  font-size: 15px;
  text-align: center;
  width: 20%;
}
.wx-btn-box{
  display: flex;
  justify-content: center;
  padding:0 20px 20px;
  background-color: #f9f0e9;
}
.wx-btn-box a{
  line-height: 45px;
  text-decoration: none;
}

.bottom-logo{
  width: 100%;
  display: block;
  margin-top: 40px;
}


/* 同仁堂定制 */
.trt{
  background-position: 0 0;
  background-size: 100% auto;
  background-image: url('/static/images/Normal06/bg.png');
  .MainOidBox ul{
    color: #906945;
    background-image: url(../../static/images/Normal06/box.png);
  }

  .MainDataInquire{
    border: 2px solid #906945;
  }

  .MainDataInquireBtn{
    background-color: #906945;
  }

  .MainBox{
    color: #906945;
  }
}

/* 通用医药定制 */
.tyyy{
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #0071b7;

  .MainOidBox ul{
    /* color: #216ad9; */
    /* background-image: url(../../static/images/Normal06/box1.png); */
  }

  .MainDataInquire{
    border: 2px solid white;
  }

  .MainDataInquireBtn{
    background-color: #0071b7;
  }

  .MainBox{
    /* color: #216ad9; */
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Normal06.vue